import {
    API,
    DynamicLoadManualManager,
    DynamicLoadManualStatic,
    getConfigTranslationsLoaded,
    getFeatureFlag,
    getTranslationsLoaded,
    initConfigAndTranslations,
    initFeatureFlag,
    initFeatureFlagPublic,
    getGlobalEventBus,
    Microfrontend,
  } from '@gruposantander/mb-ui-framework';
  import { LoadingSection } from 'commonsComponents/loadingSection';
  import PropTypes from 'prop-types';
  import React, { useEffect, useState } from 'react';
  import { useHistory } from 'react-router-dom';
  import { cookies } from '../utilities/storage';
  import { COOKIE_KEYS } from './constants/session';
  
  
  const BaseMicrofrontendRoute = ({
    microfront,
    variant,
    projectId,
    translationsConfig,
    featureFlagConfig,
  }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [featureFlag, setFeatureFlag] = useState(null);
    const [translations, setTranslations] = useState({ web: [], config: [] });
    const history = useHistory();
    const eventBus = getGlobalEventBus()
   
    const loader = new DynamicLoadManualManager(new DynamicLoadManualStatic(variant, projectId));
  
  
    useEffect(() => {
      const initialize = async () => {
        const initPromises = [];
  
        const pushFeatureFlags = initPromises => {
          if (featureFlagConfig) {
            featureFlagConfig.isRequiredPublicFF
              ? initPromises.push(initFeatureFlagPublic(featureFlagConfig, API))
              : initPromises.push(initFeatureFlag(featureFlagConfig, API));
          }
        };
  
        const pushConfigAndTranslations = async initPromises => {
          if (translationsConfig) {
            initPromises.push(await initConfigAndTranslations(API, translationsConfig));
          }
        };
  
        try {
          pushFeatureFlags(initPromises);
          await pushConfigAndTranslations(initPromises);
          await Promise.allSettled(initPromises);
          const featureFlag = getFeatureFlag();
          const translations = {
            web: getTranslationsLoaded().entries,
            config: getConfigTranslationsLoaded().entries,
          };
          setFeatureFlag(featureFlag);
          setTranslations(translations);
          setIsInitialized(true);
        } catch (e) {
          console.error('Can`t initiate feature flag or translations. Check network');
          console.error(e, 'ERROR');
        }
      };
      initialize();
    }, []);
  
    if (!isInitialized) {
      return <LoadingSection type="round" width={80} />;
    }
    
  // Manually getting cookies because the authenticator session might not be accessing the same environment.
  // This ensures that the session data matches what we have in the store.  
  const sessionData = COOKIE_KEYS.reduce((data, key) => {
    data[key] = cookies.get(key);
    return data;
  }, {}); 
  
  sessionData.accessToken = cookies.get("tokenCredential");  
  sessionData.sessionExpiresAt = new Date(cookies.get("sessionExpiresAt"))
  
    return (
      <Microfrontend
        id={microfront}
        data={{
          history,
          store: {},
          externalComponents: {},
          initializedFeatures: {},
          data: {
            history,
            featureFlag,
            eventBus,
            sessionData,
            translations,
          },
        }}
        loader={loader}
        onLoad={() => {
          console.log(`${microfront} Loaded`);
        }}
      />
    );
  };
  
  BaseMicrofrontendRoute.propTypes = {
    microfront: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    translationsConfig: PropTypes.object.isRequired,
    featureFlagConfig: PropTypes.object.isRequired,
  };
  
  export default  React.memo(BaseMicrofrontendRoute)